import { IconProps } from "./types";

export default function StackedCoinsIcon({ className }: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M21.5552 8.68054C21.5552 9.7591 20.7435 10.8992 19.0683 11.8129C17.4213 12.7113 15.0951 13.29 12.485 13.29C9.87496 13.29 7.5488 12.7113 5.90175 11.8129C4.22658 10.8992 3.41485 9.7591 3.41485 8.68054C3.41485 7.60198 4.22658 6.46187 5.90175 5.54814C7.5488 4.64975 9.87496 4.0711 12.485 4.0711C15.0951 4.0711 17.4213 4.64975 19.0683 5.54814C20.7435 6.46187 21.5552 7.60198 21.5552 8.68054Z"
        stroke="currentColor"
        strokeWidth="1.48692"
      />
      <line
        x1="3.41499"
        y1="16.6284"
        x2="3.41499"
        y2="8.51796"
        stroke="currentColor"
        strokeWidth="1.48692"
      />
      <line
        x1="21.5554"
        y1="16.6284"
        x2="21.5554"
        y2="8.51796"
        stroke="currentColor"
        strokeWidth="1.48692"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.68091 16.4819C2.91191 19.0907 7.2129 21.1702 12.4848 21.1702C17.7567 21.1702 22.0577 19.0907 22.2887 16.4819H20.7849C20.6695 16.9816 20.154 17.7046 18.7589 18.4025C17.23 19.1673 15.0139 19.6833 12.4848 19.6833C9.95573 19.6833 7.73959 19.1673 6.21073 18.4025C4.8156 17.7046 4.30009 16.9816 4.18469 16.4819H2.68091Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.67114 13.272C2.94014 15.6692 7.23101 17.5747 12.4848 17.5747C17.7387 17.5747 22.0295 15.6692 22.2985 13.272H20.7775C20.6379 13.659 20.1503 14.2752 18.8098 14.8947C17.2678 15.6074 15.0331 16.0878 12.4848 16.0878C9.93652 16.0878 7.70181 15.6074 6.15986 14.8947C4.81933 14.2752 4.33179 13.659 4.19212 13.272H2.67114Z"
        fill="currentColor"
      />
      <path
        d="M12.0999 5.63171H12.0255V5.70605V6.21617C11.4878 6.26397 11.0459 6.40991 10.7329 6.62828C10.4055 6.85677 10.2168 7.16698 10.2168 7.52311C10.2168 7.89478 10.3979 8.18493 10.7357 8.38944L10.7357 8.38945L10.7366 8.38997C11.0759 8.58902 11.5889 8.75902 12.28 8.90268L12.2806 8.9028C12.7943 9.00544 13.1373 9.10192 13.3508 9.21042C13.4569 9.26434 13.5261 9.31883 13.5687 9.37407C13.61 9.42771 13.6287 9.48513 13.6287 9.55173C13.6287 9.70576 13.546 9.83922 13.3699 9.93806C13.1913 10.0384 12.9203 10.0997 12.5623 10.0997C12.1631 10.0997 11.8623 10.032 11.6602 9.91109C11.462 9.79247 11.3555 9.62124 11.3417 9.39779L11.3374 9.32804H11.2675H10.1062H10.0287L10.0319 9.40543C10.0484 9.80691 10.2414 10.1464 10.5939 10.395C10.9314 10.6331 11.4133 10.787 12.0255 10.84V11.3563V11.4307H12.0999H12.9323H13.0067V11.3563V10.8403C13.5646 10.7934 14.0361 10.6551 14.3741 10.4372C14.7277 10.2092 14.9387 9.89088 14.9387 9.50195C14.9387 9.1494 14.7683 8.86561 14.431 8.66107C14.1107 8.45447 13.5759 8.27209 12.8249 8.11631C12.3111 7.99807 11.9591 7.89384 11.7723 7.80451C11.6824 7.76155 11.6219 7.71269 11.5837 7.65895C11.5461 7.60608 11.5268 7.54377 11.5268 7.4671C11.5268 7.32062 11.6012 7.19984 11.7509 7.11196C11.9036 7.02233 12.1329 6.96895 12.4287 6.96895C12.7289 6.96895 12.971 7.02673 13.1366 7.12699C13.2995 7.22564 13.388 7.36432 13.3924 7.53744L13.3942 7.6099H13.4667H14.6382H14.7181L14.7124 7.53023C14.6851 7.14943 14.5061 6.84345 14.1987 6.62194C13.907 6.41167 13.5024 6.27921 13.0067 6.22396V5.70605V5.63171H12.9323H12.0999Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.148692"
      />
    </svg>
  );
}
